import createBrowserHistory from 'history/createBrowserHistory';
import { List } from 'immutable';

import { bindHistoryListener } from './historyListener';
import { onEnter } from './middleware/onEnter';
import { routerMiddleware } from './middleware/routerMiddleware';
import { exportModule } from './module';
import { initialStateWithRoutes, routerState } from './state';
import { initializeCurrentLocation } from './subscribers/initializeCurrentLocation';
import { updateWindowTitle } from './subscribers/windowTitle';
import { IOnEnterFunction, IRouteMap } from './types';

// 🚂 The little router that could 🚂

export const RouterModule = (params: {
  routes: IRouteMap;
  readyForRoutes?: Promise<any>;
  globalOnEnters?: IOnEnterFunction[];
  pageTrackingCallback?(params: { pageName: string; props?: { [key: string]: any } }): void;
}) => {
  const { routes, readyForRoutes, globalOnEnters, pageTrackingCallback } = params;
  const history = createBrowserHistory({ basename: '' });

  bindHistoryListener(history);

  return exportModule({
    state: List.of({ ...routerState, initialState: initialStateWithRoutes(routes) }),
    middleware: List.of(onEnter(pageTrackingCallback, globalOnEnters), routerMiddleware({ history })),
    subscribers: List.of(initializeCurrentLocation(history, readyForRoutes), updateWindowTitle)
  });
};
